import { render, staticRenderFns } from "./ride-mouth.vue?vue&type=template&id=1a6b6b46&scoped=true&lang=pug&"
import script from "./ride-mouth.vue?vue&type=script&lang=js&"
export * from "./ride-mouth.vue?vue&type=script&lang=js&"
import style0 from "./ride-mouth.vue?vue&type=style&index=0&id=1a6b6b46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b6b46",
  null
  
)

export default component.exports